import { createClient } from '@supabase/supabase-js'

// Supabase configuration
// Get your anon key from: Supabase Dashboard → Settings → API → anon/public key
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://pwwpmepbdjezxiyhtjkr.supabase.co'
// Note: For client-side, use the anon key (starts with eyJ), not the service role key
// The key below is a placeholder - replace with your actual anon key from Supabase dashboard
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InB3d3BtZXBiZGplenhpeWh0amtyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njg2OTczOTYsImV4cCI6MjA4NDI3MzM5Nn0.MrKwBNtjyDJNDD10H6Tjm6dQieVIvBNY-0-f92358bA'

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing Supabase configuration. Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)

/** Password reset emails redirect here; whitelist the same URL in Supabase → Auth → URL Configuration → Redirect URLs. */
export function getAuthRedirectUrl() {
  if (typeof window === 'undefined') return ''
  const fromEnv = process.env.REACT_APP_SITE_URL
  if (fromEnv) return fromEnv.replace(/\/$/, '')
  return `${window.location.origin}${window.location.pathname || '/'}`
}
